import { jsx } from "@emotion/react/jsx-runtime";
import _styled from "@emotion/styled/base";
import { useTheme } from "@emotion/react";
import parseStyle from "./parseStyle.mjs";
import useThemeProps from "./useThemeProps.mjs";
import isPropValid from "@emotion/is-prop-valid";
const TypographyRoot = /* @__PURE__ */_styled("p", process.env.NODE_ENV === "production" ? {
  shouldForwardProp: prop => !["style", "color"].includes(prop) && isPropValid(prop),
  target: "e3dssjw0"
} : {
  shouldForwardProp: prop => !["style", "color"].includes(prop) && isPropValid(prop),
  target: "e3dssjw0",
  label: "TypographyRoot"
})(props => parseStyle(props.style, props.theme), " color:", props => props.theme.getColor(props.color), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
function Typography(props) {
  var _a, _b, _c;
  let theme = useTheme();
  props = useThemeProps({
    props,
    name: "Typography"
  });
  let {
    variant: variantName,
    style,
    children,
    as,
    align,
    elementMapping = {
      h1: "h1",
      h2: "h2",
      h3: "h3",
      h4: "h4",
      h5: "h5",
      h6: "h6",
      body: "p",
      caption: "p",
      description: "p"
    },
    marginBefore = false,
    marginAfter = false,
    color,
    maxLineLength = "80ch",
    ...restProps
  } = props;
  if (Array.isArray(variantName)) {
    variantName = variantName.find(variantName2 => {
      var _a2, _b2;
      return (_b2 = (_a2 = theme.typography) == null ? void 0 : _a2.variants) == null ? void 0 : _b2[variantName2];
    });
  }
  let variant = (_b = (_a = theme.typography) == null ? void 0 : _a.variants) == null ? void 0 : _b[variantName];
  let {
    element,
    ...variantStyles
  } = variant || {};
  as = as || element || elementMapping[variantName];
  style = {
    maxWidth: ((_c = theme.typography) == null ? void 0 : _c.maxLineLength) || maxLineLength,
    ...variantStyles,
    marginBlockStart: marginBefore ? null : 0,
    marginBlockEnd: marginAfter ? null : 0,
    marginInlineStart: ["right", "end", "center"].includes(align) ? "auto" : null,
    marginInlineEnd: ["left", "start", "center"].includes(align) ? "auto" : null,
    textAlign: align,
    ...style
  };
  return /* @__PURE__ */jsx(TypographyRoot, {
    as,
    color,
    style,
    ...restProps,
    children
  });
}
export { Typography as default };